import React, { useState } from 'react';
import BugReportIcon from '@mui/icons-material/BugReport';
import { BugsModal } from './BugsModal';
import { getTotalBugCount } from '../../data/knownBugs';

interface BugsButtonProps {
  className?: string;
}

/**
 * Bugs button component
 * Opens a modal showing known bugs and issues
 */
export const BugsButton: React.FC<BugsButtonProps> = ({ className = '' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bugCount = getTotalBugCount();

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Bugs Button */}
      <button
        onClick={handleClick}
        className={`relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group ${className}`}
        aria-label="View known bugs"
        title={`View known bugs (${bugCount} pending)`}
      >
        <BugReportIcon sx={{ fontSize: 20 }} className="text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-100" />
        
        {/* Bug Count Badge */}
        {bugCount > 0 && (
          <span className="absolute top-0 right-0 flex items-center justify-center h-4 w-4 text-xs font-bold bg-red-500 text-white rounded-full">
            {bugCount > 9 ? '9+' : bugCount}
          </span>
        )}
      </button>

      {/* Bugs Modal */}
      <BugsModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

